// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"499":"818cd3a5","553":"d34b103a"}[chunkId] + ".chunk.js";
};